import { createContext, useContext } from 'react';
import { TipType } from '../../api';
import { OrderPageIntent } from '../OrderPageIntent';
import { orderPageInitialState, OrderPageState } from './OrderPageState';

export type OrderPageContextType = {
  reloadDates: () => void;
  orderPageState: OrderPageState;
  setOrderDetailValue: (dataType: string, value: any) => void;
  setCustomOrderDetailValue: (name: string, value: any) => void;
  setOrderCustomDetails: (customDetails: Record<string, any>) => void;
  setMultipleTicketsDetails: (customDetails: Record<string, any>) => void;
  setOrderPageState: (val: OrderPageState) => void;
  setPersonalDetails: (personalDetails: Record<string, any>) => void;
  setDate: (date: any) => void;
  setTime: (time: any) => void;
  setPaymentUrl: (val: string) => void;
  setActiveStep: (val: number) => void;
  setActiveStepAndOrderPageIntent: (activeStep: number, orderPageIntent: OrderPageIntent) => void;
  setTip: (type: TipType, value: number) => void;
  disclaimersAccepted: boolean;
  disclaimersError: boolean;
  setDisclaimersError: (v: boolean) => void;
  onDisclaimersChange: (accepted: boolean) => void;
  sessionTtlMilliseconds: number | null;
  setSessionTtlMilliseconds: (v: number | null) => void;
};
export const OrderPageContext = createContext<OrderPageContextType>({
  reloadDates: () => {},
  orderPageState: orderPageInitialState,
  setOrderDetailValue: (_dataType: string, _value: any) => {},
  setCustomOrderDetailValue: (_name: string, _value: any) => {},
  setOrderCustomDetails: (_customDetails: Record<string, any>) => {},
  setMultipleTicketsDetails: (_customDetails: Record<string, any>) => {},
  setOrderPageState: (_val: OrderPageState) => {},
  setPersonalDetails: (_personalDetails: Record<string, any>) => {},
  setDate: (_date: any) => {},
  setTime: (_time: any) => {},
  setPaymentUrl: (_val: string) => {},
  setActiveStep: (_val: number) => {},
  setActiveStepAndOrderPageIntent: (_activeStep: number, _orderPageIntent: OrderPageIntent) => {},
  setTip: (_type: TipType, _value: number) => {},
  disclaimersAccepted: false,
  disclaimersError: false,
  setDisclaimersError: () => {},
  onDisclaimersChange: () => {},
  sessionTtlMilliseconds: null,
  setSessionTtlMilliseconds: () => {},
});

export const useOrderPage = () => useContext(OrderPageContext);
